import React from 'react';
import { graphql } from 'gatsby';
import ArticleTemplate, { ArticleType } from '../components/ArticleTemplate';
import Cookie from '../components/shared/Cookie';

const Article = ({ data }) => {
  const { wordpressPage: page, wordpressSiteMetadata: siteMeta } = data;

  return (
    <>
      <ArticleTemplate
        article={page}
        articleType={ArticleType.article}
        siteMeta={siteMeta}
        yoastMeta={page.yoastMeta}
      />
      <Cookie />
    </>
  );
};

export const pageQuery = graphql`
  query ArticleById($id: String!) {
    wordpressPage(id: { eq: $id }) {
      acf {
        heroImage: hero_image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
        imagePositioning: image_positioning {
          vertical: vertical_adjustment
          horizontal: horizontal_adjustment
        }
        blocks: article_page {
          __typename
          ...Article_HeadingBlockFragment
          ...Article_TextBlockFragment
          ...Article_ImageBlockFragment
          ...ArticleTableBlockFragment
        }
      }
    }
    ...WordpressSiteMetadataFragment
  }
`;

export default Article;
